import { Component, EventEmitter,ViewChild, Output,Input } from '@angular/core';
import { SecurityService } from '@core/Security/security.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { ConfigService } from '@core/Abstract/config.service';
import { AuthService } from '../../../../Core/Auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-changeLanguage',
  templateUrl: './changeLanguage.component.html'
})
export class ChangeLanguageComponent {
  @Input() langs;
  @Input() currentLang;
  @Output() changeLang = new EventEmitter<void>();

  constructor(private securityService: SecurityService,
    public translate:TranslateService,
    private eventsEmitterService: EventsEmitterService,
    public authService:AuthService,
    protected configService: ConfigService) {
  } 

  ngOnInit(){  }

  changeLanguage(event){
    this.changeLang.emit(event);

  }
}
